<template>
  <div class="page">
    <van-nav-bar left-text="活动规则" left-arrow @click-left="goBack">
      <van-icon name="cross" size="18" slot="right" @click="goBack" />
    </van-nav-bar>

    <div class="content-wrapper">
      <div class="content-container">
        <h4>活动参与要求</h4>
        <p>所有金拇指系统内，注册的用户均可参与免费拿活动。</p>
        <h4>活动基本规则</h4>
        <ul>
          <li>1. 同一个用户账号、手机号、手机终端，符合以上任一条件的，均视为同一用户；</li>
          <li>2. 同一店铺活动，同一用户只可领1份免费拿产品；</li>
          <li>3. 免费拿产品数量有限，先播先得，拿完即止。</li>
          <li>4. 被判定为已失效的产品/活动状态，系统不补发产品、已播人数不累计叠加；</li>
          <li>5. 免费拿产品兑换期限及具体使用规则，以商家发布的信息为准；对活动有疑问，请联系商家进行处理。</li>
          <li>
            6.
            如出现不可抗力或情势变更的情况，如自然灾害时间，活动受政府机关指令、系统平台限制需要停止举办或调整等，金拇指可免于承担责任。
          </li>
          <li>
            7.
            活动商户及金拇指可在法律规定范围内对活动规则进行变更或调整（如有），相关变动或调整将公布在活动页面上，或以短信、页面消息、公告等合适的方式及时通知。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background-image: linear-gradient(to right, #ff5959, #ffb88a);

  .van-nav-bar {
    background: transparent;

    /deep/ .van-icon,
    /deep/ .van-nav-bar__text {
      font-size: 18px !important;
      color: #fff !important;
    }
  }

  .van-hairline--bottom::after {
    display: none;
  }

  .content-wrapper {
    width: 342px;
    min-height: 424px;
    margin: 10px auto;
    border-radius: 8px;
    background-color: #fff;

    .content-container {
      padding: 14px 15px 35px 15px;
      font-size: 12px;
      line-height: 20px;
      color: #414141;
    }
  }
}
</style>
